import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'ps-design';
import Aging from '../../containers/Aging/Aging';

import './Menu.scss';
import { MenuDropdownButton } from '../common';

class AccountMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
    }
  }

  getShowOverlay = (showOverlay) => {
    this.setState({
      showOverlay: showOverlay
    });
  }
  render() {
    const { orgCode, openChangePasswordModal } = this.props;

    return (
      <Dropdown ref={this.dropRef} btnClass="dropdown" btnText="Profile"
        iconClass="icon-user" id="admin-menu" dropdownClass="menu"
        showOverlay={this.state.showOverlay}>
        {/* <Link className="pxl-dropdown__item" to={`/view/${orgCode}/profile`}>
          Profile
        </Link> */}
        <Aging className="dropdown__item--aging" getShowOverlay={this.getShowOverlay} />
        <MenuDropdownButton onClick={openChangePasswordModal}>
          Change Password
        </MenuDropdownButton>
        <MenuDropdownButton onClick={() => window.location.replace(`${window.location.origin}/${orgCode}/app/auth/logout`)}>
          Logout
        </MenuDropdownButton>
      </Dropdown>
    );
  }
}

AccountMenu.propTypes = {
  orgCode: PropTypes.string,
  config: PropTypes.object,
  location: PropTypes.object
};

export default AccountMenu;
